var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.zulp.length > 0) ? _vm._l((_vm.zulp), function(z) {
    return _c('div', {
      staticClass: "card-text",
      attrs: {
        "data-testid": 'visit-zulp-' + z.id
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-between border border-light"
    }, [_c('div', {
      staticClass: "p-0"
    }, [_vm._v("\n                    " + _vm._s(z.medicine.label) + " "), _c('span', [_vm._v(" množství: " + _vm._s(z.amount) + " ")]), _vm._v(" úhrada: " + _vm._s(z.insurance_cover_sequence_number) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "p-0"
    }, [(!_vm.zulpPending) ? _c('button', {
      staticClass: "btn btn-sm btn-outline-danger",
      attrs: {
        "data-testid": 'visit-zulp-delete-' + z.id
      },
      on: {
        "click": function($event) {
          _vm.zulpPending ? null : _vm.removeZulp(z.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _c('button', {
      staticClass: "btn btn-sm btn-outline-danger disabled"
    }, [_c('i', {
      staticClass: "fa fa-trash-o",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])
  }) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7700dbe5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Visit/components/ListZulp.vue
// module id = 515
// module chunks = 0